<template>
  <AdblockTopbar />
  <div class="px-4 sm:px-6 lg:px-16 max-w-screen-xl lg:mx-auto">
    <HeaderApp />
    <div class="text__view flex flex-col justify-center text-center mb-5">
      <h1 class="font-semibold text-2xl my-5">
        {{ tiktok_title_subtitle.title }}
      </h1>
      <p class="leading-6 max-w-5xl mx-auto">
        {{ tiktok_title_subtitle.subtitle.split("|")[0]
        }}<a class="italic text-gray-600" href="/our-process" target="_blank">{{
          tiktok_title_subtitle.subtitle.split("|")[1]
        }}</a
        >{{ tiktok_title_subtitle.subtitle.split("|")[2] }}
      </p>
    </div>
    <div
      class="italic flex flex-col justify-center text-center mb-5 text-xl my-10"
    >
      <vue-countdown
        :time="time_difference"
        v-slot="{ days, hours, minutes, seconds }"
      >
        <template v-if="roleUser == 'free'">
          <div class="flex inline-flex">
            <router-link to="/pricing">
              <Button class="px-8 bg-indigo-600 hover:bg-indigo-500 text-white"
                >Join Today</Button
              >
            </router-link>
          </div>
          and don’t miss out the next 100+ viral Tiktok ads in {{ days }} days,
          {{ hours }} hours, {{ minutes }} minutes, {{ seconds }} seconds.
        </template>
        <template v-else>
          100+ new Tiktok ads coming in
          {{ days }} days, {{ hours }} hours, {{ minutes }} minutes,
          {{ seconds }} seconds.
        </template>
      </vue-countdown>
    </div>
    <FiltersTiktok
      :active_filters="{
        industry: true,
        objective: false,
        type: false,
        format: false,
        month: true,
      }"
      :origin="'tiktoks'"
      class="hidden xl:grid grid-cols-6 grid-flow-col justify-center items-center"
    />
    <template v-if="tiktoks && tiktoks.length">
      <div
        class="library__list py-4 lg:py-10 items-start"
        v-if="tiktoks && tiktoks.length"
      >
        <TiktokVideo
          v-for="tiktok in tiktoks"
          :key="tiktok.id"
          :data="tiktok"
          class="library__item"
          :isCollection="false"
        />
      </div>
    </template>
    <template v-else>
      <div
        class="grid mt-24 p-8 text-center justify-center items-center content-center my-auto"
      >
        <div>
          <h2 class="text-4xl font-semibold mb-4">
            Looking for Tiktoks 👀
          </h2>
          <p class="mb-10 text-lg">
            We recommend clean the filters
          </p>
          <div class="flex justify-center">
            <Button
              @click="getInitialTiktoks()"
              class="px-12 bg-indigo-600 hover:bg-indigo-500 text-white"
              >Clean filters</Button
            >
          </div>
        </div>
      </div>
    </template>

    <Pagination
      :totalElements="totalTiktoks"
      :pageView="pageNumber"
      nameView="Tiktoks"
    />
  </div>
</template>

<script>
import { computed, onBeforeMount } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import HeaderApp from "@/components/Header";
import AdblockTopbar from "@/components/AdblockTopbar";
import TiktokVideo from "@/components/TiktokVideo/index";
import Pagination from "@/components/Pagination";
import Button from "@/components/UI/Button";
import FiltersTiktok from "@/components/FiltersTiktok";
import VueCountdown from "@chenfengyuan/vue-countdown";
export default {
  components: {
    HeaderApp,
    TiktokVideo,
    AdblockTopbar,
    Button,
    Pagination,
    FiltersTiktok,
    VueCountdown,
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    onBeforeMount(async () => {
      const status = computed(() => store.state.status);
      if (!status.value) {
            console.log("1")

        router.push("/pricing");
      } else {
        await store.dispatch("GET_TIKTOKS", { idUser: user.value.id });
      }
    });
    const tiktoks = computed(() => store.state.tiktoks);
    const user = computed(() => store.state.user);
    const tiktok_title_subtitle = computed(
      () => store.state.tiktokTitleSubtitle
    );
    const pageNumber = computed(() => store.state.pageTiktoks);
    const totalTiktoks = computed(() => store.state.totalTiktoks);
    const roleUser = computed(() => store.state.role);
    const getInitialTiktoks = () => {
      store.commit("CLEAN_FILTERS_TIKTOKS");
    };

    var now = new Date();
    var next_month = new Date(now.getFullYear(), now.getMonth() + 1, 1);
    next_month.setHours(12);
    next_month.setMinutes(1);
    let time_difference = next_month - now;
    return {
      tiktoks,
      roleUser,
      tiktok_title_subtitle,
      pageNumber,
      totalTiktoks,
      getInitialTiktoks,
      time_difference,
    };
  },
};
</script>

<style scoped>
.library__list {
  @apply grid gap-y-10 gap-x-10;
  justify-content: space-between;
  grid-template-columns: repeat(auto-fit, minmax(19rem, 22rem));
}
.library__item {
  max-width: 24rem;
  min-width: 18rem;
  width: 100%;
}
</style>
